import React from 'react'
import ThankYouNoteProvider, { useThankYouNote } from './ThankYouNoteProvider'
import { TemplateProvider, initializeTemplates } from '../../lib/pdf'
import * as T0 from './Template0'

// These need to be declared outside of a component so they can't affect rendering
const [templates, templateStyle, templateSupportedStyles] = initializeTemplates(
  [T0],
)

const StandaloneViewer = ({ ...props }) => {
  const { template_settings, template_index } = props
  const defaultStyle = template_settings
    ? {
        ...templateStyle,
        [`template-${template_index}`]: template_settings,
      }
    : templateStyle
  const templateProps = {
    templates,
    defaultStyle,
    templateSupportedStyles,
    template_index,
  }

  return (
    <TemplateProvider {...templateProps}>
      <ThankYouNoteProvider {...props}>
        <div id="resume-pdf-preview" className="relative md:flex-grow">
          <div className="w-full md:sticky md:left-0 md:top-0 md:h-screen">
            <PdfViewer {...props} />
          </div>
        </div>
      </ThankYouNoteProvider>
    </TemplateProvider>
  )
}
export default StandaloneViewer

const PdfViewer = () => {
  const {
    pdf: { url, loading },
  } = useThankYouNote()

  if (loading) {
    return null
  }
  return (
    <iframe
      src={`${url}#navpanes=0`}
      className="h-full w-full"
      title="Resume Preview"
      frameBorder="0"
      loading="lazy"
    />
  )
}
